const globalDisabledKey = 'timelining:screen-guides:disabled'
const seenKeyPrefix = 'timelining:screen-guides:seen:'

const safeLocalStorage = () => {
  if (typeof window === 'undefined') return null
  try {
    return window.localStorage
  } catch {
    return null
  }
}

export const areScreenGuidesDisabled = (): boolean => {
  try {
    const storage = safeLocalStorage()
    return storage?.getItem(globalDisabledKey) === 'true'
  } catch {
    return false
  }
}

export const setScreenGuidesDisabled = (disabled: boolean) => {
  try {
    const storage = safeLocalStorage()
    if (!storage) return
    if (disabled) storage.setItem(globalDisabledKey, 'true')
    else storage.removeItem(globalDisabledKey)
  } catch {
    // ignore
  }
}

export const hasSeenScreenGuide = (screenId: string): boolean => {
  try {
    const storage = safeLocalStorage()
    return storage?.getItem(`${seenKeyPrefix}${screenId}`) === 'true'
  } catch {
    return false
  }
}

export const markScreenGuideSeen = (screenId: string) => {
  try {
    const storage = safeLocalStorage()
    storage?.setItem(`${seenKeyPrefix}${screenId}`, 'true')
  } catch {
    // ignore
  }
}
